<ng-otp-input style="background: white" inputClass="verify-focus bg-white w-fit focus:bg-blue-600
" (onInputChange)="onOtpInputChange($event)" [config]="{ length: 4, allowNumbersOnly: true }"></ng-otp-input>